(function () {
  'use strict';

  /**
   * Prevents cross-account cart leakage only.
   * Does NOT clear the cart on logout — Shopify keeps each customer's cart
   * server-side; the same user gets it back on re-login.
   */
  var STORAGE_KEY = 'fr_last_customer_id';
  var cfg = window.__FR_CUSTOMER_HANDOFF__ || {};
  var currentId = cfg.customerId != null && cfg.customerId !== '' ? String(cfg.customerId) : null;

  function clearWpdLocalStorage() {
    try {
      localStorage.removeItem('wpd_integration_fbt_bundle');
    } catch (e) {}
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).catch(function () {});
  }

  function handleCustomerSwitch() {
    var stored = null;
    try {
      stored = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {}

    if (!currentId) return;

    if (stored && stored !== currentId) {
      clearWpdLocalStorage();
      clearCart().finally(function () {
        try {
          sessionStorage.setItem(STORAGE_KEY, currentId);
        } catch (e) {}
        window.location.reload();
      });
      return;
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, currentId);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleCustomerSwitch);
  } else {
    handleCustomerSwitch();
  }
})();
